import React, { Fragment, useState, useEffect } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { addAddressBook } from "../../actions/addressbook";

import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import {
  TextField,
  FormControl,
  OutlinedInput,
  Input,
  InputLabel,
  InputAdornment,
} from "@material-ui/core";
const EditAddressBook = (props) => {
  const [value, setValue] = useState({
    success: false,
    firstName: "",
    lastName: "",
    company: "",
    country: "",
    address: "",
    firstNameError: "",
    lastNameError: "",
    cityError: "",
    postCodeError: "",
    regionError: "",
    addressError: "",
    city: "",
    postCode: "",
    region: "",
    defaultAddress: 0,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValue({ [name]: value });
  };

  const onSubmit = async () => {
    const formData = value;
    const res = await props.addAddressBook(formData);
    props.history.push("/checkout");
    // if (
    //   formData.firstName.charAt(0) === "0" ||
    //   formData.firstName.charAt(0) === "1" ||
    //   formData.firstName.charAt(0) === "2" ||
    //   formData.firstName.charAt(0) === "3" ||
    //   formData.firstName.charAt(0) === "4" ||
    //   formData.firstName.charAt(0) === "5" ||
    //   formData.firstName.charAt(0) === "6" ||
    //   formData.firstName.charAt(0) === "7" ||
    //   formData.firstName.charAt(0) === "8" ||
    //   formData.firstName.charAt(0) === "9" ||
    //   formData.firstName.length < 3
    // ) {
    //   setValue({
    //     firstNameError: "Enter Your Correct First Name",
    //   });
    //   return;
    // }
    // if (formData.lastName.length < 4) {
    //   setValue({
    //     lastNameError: "Enter Your Correct Last Name",
    //   });
    //   return;
    // }
    // if (formData.address.length < 10) {
    //   setValue({
    //     addressError: "Enter Address At Least 10 Characters",
    //   });
    //   return;
    // }
    // if (
    //   formData.city.charAt(0) === "0" ||
    //   formData.city.charAt(0) === "1" ||
    //   formData.city.charAt(0) === "2" ||
    //   formData.city.charAt(0) === "3" ||
    //   formData.city.charAt(0) === "4" ||
    //   formData.city.charAt(0) === "5" ||
    //   formData.city.charAt(0) === "6" ||
    //   formData.city.charAt(0) === "7" ||
    //   formData.city.charAt(0) === "8" ||
    //   formData.city.charAt(0) === "9" ||
    //   formData.city.length < 4
    // ) {
    //   setValue({
    //     lastNameError: "Enter Valid City Name",
    //   });
    //   return;
    // }
    // if (formData.postCode.length < 1) {
    //   setValue({
    //     lastNameError: "Zip code Required",
    //   });
    //   return;
    // }
    // if (
    //   formData.region.charAt(0) === "0" ||
    //   formData.region.charAt(0) === "1" ||
    //   formData.region.charAt(0) === "2" ||
    //   formData.region.charAt(0) === "3" ||
    //   formData.region.charAt(0) === "4" ||
    //   formData.region.charAt(0) === "5" ||
    //   formData.region.charAt(0) === "6" ||
    //   formData.region.charAt(0) === "7" ||
    //   formData.region.charAt(0) === "8" ||
    //   formData.region.charAt(0) === "9" ||
    //   formData.region.length < 4
    // ) {
    //   setValue({
    //     lastNameError: "Enter Valid State Name",
    //   });
    //   return;
    // }
    // if (res === "Address book created!") {
    //   // setValue({
    //   //   success: "Address Add Successfully",
    //   //   class: "alert-success",
    //   // });
    //   // setTimeout(() => {
    //   //   setValue({ success: null });
    //   // }, 3000);
    //   setValue({
    //     firstName: "",
    //     lastName: "",
    //     company: "",
    //     country: "",
    //     address: "",
    //     city: "",
    //     postCode: "",
    //     region: "",
    //   });
    //   if (localStorage.getItem("cart").length === 2) {
    //     props.history.push({
    //       pathname: "/address-book",
    //       successMessage: "Address Added Successfully",
    //     });
    //   } else {
    //     props.history.push("/checkout");
    //   }
    // } else {
    //   setValue({ success: "Something went wrong", class: "alert-danger" });
    //   setTimeout(() => {
    //     setValue({ success: null });
    //   }, 4000);
    // }
  };

  const {
    firstName,
    lastName,
    company,
    address,
    city,
    country,
    postCode,
    region,
    defaultAddress,
  } = value;
  return (
    <Fragment>
      <div className="update-address-wrapper wrapper-90 max-1600">
        <ul className="breadcrumb">
          <li>
            <Link to={"/"}>
              <i className="fa fa-home" />
            </Link>
          </li>
          <li>
            <Link to="/dashboard"> / Account</Link>
          </li>
          <li>
            <a href=""> / Add address book</a>
          </li>
        </ul>
        <div className="container-fluid px-0">
          <div className="row">
            <AccountLeftSidebar />
            <div className="col-md-9">
              <header className="update-address-header">
                <h3>Add an Address</h3>
                {value.success && (
                  <div
                    key={alert.id}
                    variant={alert.alertType}
                    className={`alert ${value.class && value.class}`}
                    role="alert"
                    style={{ marginTop: "3em", marginBottom: "2em" }}
                  >
                    {value.success}
                  </div>
                )}
              </header>
              <form action="#" id="addressForm">
                <div className="address-form-content">
                  <div className="address-inputs">
                    <div className="address-nickname">
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="firstName"
                          name="firstName"
                          onChange={handleChange}
                          error={
                            value.firstNameError && value.firstNameError !== ""
                              ? true
                              : false
                          }
                          label="First Name"
                          helperText={
                            value.firstNameError && value.firstNameError
                          }
                        />
                      </FormControl>
                      {/*    <label
                          htmlFor="addressnickname"
                          className="address-inputLabel nickname-inp"
                        >
                          <input
                            type="text"
                            className="address-inp"
                            value={firstName}
                            onChange={(e) => {
                              setValue({ firstName: e.target.value });
                            }}
                          />
                          <span className="address-placeholders">
                            First Name
                          </span>
                        </label> */}
                    </div>
                  </div>
                  <div className="address-inputs">
                    <div className="address-name">
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="lastName"
                          name="lastName"
                          maxLength={32}
                          onChange={handleChange}
                          error={
                            value.lastNameError && value.lastNameError !== ""
                              ? true
                              : false
                          }
                          label="Last Name"
                          helperText={
                            value.lastNameError && value.lastNameError
                          }
                        />
                      </FormControl>
                      {/*  <label
                          htmlFor="name"
                          className="address-inputLabel add-name-inp"
                        >
                          <input
                            type="text"
                            className="address-inp"
                            value={lastName}
                            onChange={(e) => {
                              setValue({ lastName: e.target.value });
                            }}
                          />
                          <span className="address-placeholders">
                            Last Name
                          </span>
                        </label> */}
                    </div>
                  </div>
                  <div className="address-inputs">
                    <div className="address1-2-city">
                      <div className="address1">
                        <FormControl variant="outlined" className="my-2">
                          <TextField
                            variant="outlined"
                            id="address"
                            name="address"
                            maxLength={32}
                            onChange={handleChange}
                            error={
                              value.addressError && value.addressError !== ""
                                ? true
                                : false
                            }
                            label=" Address 1"
                            helperText={
                              value.addressError && value.addressError
                            }
                          />
                        </FormControl>
                        {/*  <label
                            htmlFor="address1"
                            className="address-inputLabel add-name-inp"
                          >
                            <input
                              type="text"
                              className="address-inp"
                              value={address}
                              onChange={(e) => {
                                setValue({ address: e.target.value });
                              }}
                            />
                            <span className="address-placeholders">
                              Address 1
                            </span>
                          </label> */}
                      </div>

                      <div className="address-cityTown">
                        <FormControl variant="outlined" className="my-2">
                          <TextField
                            variant="outlined"
                            id="city"
                            name="city"
                            maxLength={32}
                            onChange={handleChange}
                            error={
                              value.cityError && value.cityError !== ""
                                ? true
                                : false
                            }
                            label=" City/Town"
                            helperText={value.cityError && value.cityError}
                          />
                        </FormControl>
                        {/*   <label
                            htmlFor="cityTown"
                            className="address-inputLabel add-name-inp"
                          >
                            <input
                              type="text"
                              className="address-inp"
                              value={city}
                              onChange={(e) => {
                                setValue({ city: e.target.value });
                              }}
                            />
                            <span className="address-placeholders">
                              City/Town
                            </span>
                          </label> */}
                      </div>
                    </div>
                  </div>
                  <div className="address-inputs">
                    <div className="address-zip-contry-state">
                      <div className="address-zip">
                        <FormControl variant="outlined" className="my-2">
                          <TextField
                            variant="outlined"
                            id="postCode"
                            name="postCode"
                            maxLength={32}
                            onChange={handleChange}
                            error={
                              value.postCodeError && value.postCodeError !== ""
                                ? true
                                : false
                            }
                            label="Zip"
                            helperText={
                              value.postCodeError && value.postCodeError
                            }
                          />
                        </FormControl>
                        {/* <label
                            htmlFor="zipcode"
                            className="address-inputLabel add-zip"
                          >
                            <input
                              type="text"
                              className="address-inp"
                              value={postCode}
                              onChange={(e) => {
                                setValue({ postCode: e.target.value });
                              }}
                            />
                            <span className="address-placeholders">Zip</span>
                          </label> */}
                      </div>
                      <div className="checkout-inps">
                        <span className="selectcountry-hint">
                          Select Contry
                        </span>
                        <select
                          className="countrySelect"
                          value={country}
                          onChange={handleChange}
                        >
                          <option value="Afghanistan">Afghanistan</option>
                          <option value="Åland Islands">Åland Islands</option>
                          <option value="Albania">Albania</option>
                          <option value="Algeria">Algeria</option>
                          <option value="American Samoa">American Samoa</option>
                          <option value="Andorra">Andorra</option>
                          <option value="Angola">Angola</option>
                          <option value="Anguilla">Anguilla</option>
                          <option value="Antarctica">Antarctica</option>
                          <option value="Antigua and Barbuda">
                            Antigua and Barbuda
                          </option>
                          <option value="Argentina">Argentina</option>
                          <option value="Armenia">Armenia</option>
                          <option value="Aruba">Aruba</option>
                          <option value="Australia">Australia</option>
                          <option value="Austria">Austria</option>
                          <option value="Azerbaijan">Azerbaijan</option>
                          <option value="Bahamas">Bahamas</option>
                          <option value="Bahrain">Bahrain</option>
                          <option value="Bangladesh">Bangladesh</option>
                          <option value="Barbados">Barbados</option>
                          <option value="Belarus">Belarus</option>
                          <option value="Belgium">Belgium</option>
                          <option value="Belize">Belize</option>
                          <option value="Benin">Benin</option>
                          <option value="Bermuda">Bermuda</option>
                          <option value="Bhutan">Bhutan</option>
                          <option value="Bolivia">Bolivia</option>
                          <option value="Bosnia and Herzegovina">
                            Bosnia and Herzegovina
                          </option>
                          <option value="Botswana">Botswana</option>
                          <option value="Bouvet Island">Bouvet Island</option>
                          <option value="Brazil">Brazil</option>
                          <option value="British Indian Ocean Territory">
                            British Indian Ocean Territory
                          </option>
                          <option value="Brunei Darussalam">
                            Brunei Darussalam
                          </option>
                          <option value="Bulgaria">Bulgaria</option>
                          <option value="Burkina Faso">Burkina Faso</option>
                          <option value="Burundi">Burundi</option>
                          <option value="Cambodia">Cambodia</option>
                          <option value="Cameroon">Cameroon</option>
                          <option value="Canada">Canada</option>
                          <option value="Cape Verde">Cape Verde</option>
                          <option value="Cayman Islands">Cayman Islands</option>
                          <option value="Central African Republic">
                            Central African Republic
                          </option>
                          <option value="Chad">Chad</option>
                          <option value="Chile">Chile</option>
                          <option value="China">China</option>
                          <option value="Christmas Island">
                            Christmas Island
                          </option>
                          <option value="Cocos (Keeling) Islands">
                            Cocos (Keeling) Islands
                          </option>
                          <option value="Colombia">Colombia</option>
                          <option value="Comoros">Comoros</option>
                          <option value="Congo">Congo</option>
                          <option value="Congo, The Democratic Republic of The">
                            Congo, The Democratic Republic of The
                          </option>
                          <option value="Cook Islands">Cook Islands</option>
                          <option value="Costa Rica">Costa Rica</option>
                          <option value="Cote D'ivoire">Cote D'ivoire</option>
                          <option value="Croatia">Croatia</option>
                          <option value="Cuba">Cuba</option>
                          <option value="Cyprus">Cyprus</option>
                          <option value="Czech Republic">Czech Republic</option>
                          <option value="Denmark">Denmark</option>
                          <option value="Djibouti">Djibouti</option>
                          <option value="Dominica">Dominica</option>
                          <option value="Dominican Republic">
                            Dominican Republic
                          </option>
                          <option value="Ecuador">Ecuador</option>
                          <option value="Egypt">Egypt</option>
                          <option value="El Salvador">El Salvador</option>
                          <option value="Equatorial Guinea">
                            Equatorial Guinea
                          </option>
                          <option value="Eritrea">Eritrea</option>
                          <option value="Estonia">Estonia</option>
                          <option value="Ethiopia">Ethiopia</option>
                          <option value="Falkland Islands (Malvinas)">
                            Falkland Islands (Malvinas)
                          </option>
                          <option value="Faroe Islands">Faroe Islands</option>
                          <option value="Fiji">Fiji</option>
                          <option value="Finland">Finland</option>
                          <option value="France">France</option>
                          <option value="French Guiana">French Guiana</option>
                          <option value="French Polynesia">
                            French Polynesia
                          </option>
                          <option value="French Southern Territories">
                            French Southern Territories
                          </option>
                          <option value="Gabon">Gabon</option>
                          <option value="Gambia">Gambia</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Germany">Germany</option>
                          <option value="Ghana">Ghana</option>
                          <option value="Gibraltar">Gibraltar</option>
                          <option value="Greece">Greece</option>
                          <option value="Greenland">Greenland</option>
                          <option value="Grenada">Grenada</option>
                          <option value="Guadeloupe">Guadeloupe</option>
                          <option value="Guam">Guam</option>
                          <option value="Guatemala">Guatemala</option>
                          <option value="Guernsey">Guernsey</option>
                          <option value="Guinea">Guinea</option>
                          <option value="Guinea-bissau">Guinea-bissau</option>
                          <option value="Guyana">Guyana</option>
                          <option value="Haiti">Haiti</option>
                          <option value="Heard Island and Mcdonald Islands">
                            Heard Island and Mcdonald Islands
                          </option>
                          <option value="Holy See (Vatican City State)">
                            Holy See (Vatican City State)
                          </option>
                          <option value="Honduras">Honduras</option>
                          <option value="Hong Kong">Hong Kong</option>
                          <option value="Hungary">Hungary</option>
                          <option value="Iceland">Iceland</option>
                          <option value="India">India</option>
                          <option value="Indonesia">Indonesia</option>
                          <option value="Iran, Islamic Republic of">
                            Iran, Islamic Republic of
                          </option>
                          <option value="Iraq">Iraq</option>
                          <option value="Ireland">Ireland</option>
                          <option value="Isle of Man">Isle of Man</option>
                          <option value="Israel">Israel</option>
                          <option value="Italy">Italy</option>
                          <option value="Jamaica">Jamaica</option>
                          <option value="Japan">Japan</option>
                          <option value="Jersey">Jersey</option>
                          <option value="Jordan">Jordan</option>
                          <option value="Kazakhstan">Kazakhstan</option>
                          <option value="Kenya">Kenya</option>
                          <option value="Kiribati">Kiribati</option>
                          <option value="Korea, Democratic People's Republic of">
                            Korea, Democratic People's Republic of
                          </option>
                          <option value="Korea, Republic of">
                            Korea, Republic of
                          </option>
                          <option value="Kuwait">Kuwait</option>
                          <option value="Kyrgyzstan">Kyrgyzstan</option>
                          <option value="Lao People's Democratic Republic">
                            Lao People's Democratic Republic
                          </option>
                          <option value="Latvia">Latvia</option>
                          <option value="Lebanon">Lebanon</option>
                          <option value="Lesotho">Lesotho</option>
                          <option value="Liberia">Liberia</option>
                          <option value="Libyan Arab Jamahiriya">
                            Libyan Arab Jamahiriya
                          </option>
                          <option value="Liechtenstein">Liechtenstein</option>
                          <option value="Lithuania">Lithuania</option>
                          <option value="Luxembourg">Luxembourg</option>
                          <option value="Macao">Macao</option>
                          <option value="Macedonia, The Former Yugoslav Republic of">
                            Macedonia, The Former Yugoslav Republic of
                          </option>
                          <option value="Madagascar">Madagascar</option>
                          <option value="Malawi">Malawi</option>
                          <option value="Malaysia">Malaysia</option>
                          <option value="Maldives">Maldives</option>
                          <option value="Mali">Mali</option>
                          <option value="Malta">Malta</option>
                          <option value="Marshall Islands">
                            Marshall Islands
                          </option>
                          <option value="Martinique">Martinique</option>
                          <option value="Mauritania">Mauritania</option>
                          <option value="Mauritius">Mauritius</option>
                          <option value="Mayotte">Mayotte</option>
                          <option value="Mexico">Mexico</option>
                          <option value="Micronesia, Federated States of">
                            Micronesia, Federated States of
                          </option>
                          <option value="Moldova, Republic of">
                            Moldova, Republic of
                          </option>
                          <option value="Monaco">Monaco</option>
                          <option value="Mongolia">Mongolia</option>
                          <option value="Montenegro">Montenegro</option>
                          <option value="Montserrat">Montserrat</option>
                          <option value="Morocco">Morocco</option>
                          <option value="Mozambique">Mozambique</option>
                          <option value="Myanmar">Myanmar</option>
                          <option value="Namibia">Namibia</option>
                          <option value="Nauru">Nauru</option>
                          <option value="Nepal">Nepal</option>
                          <option value="Netherlands">Netherlands</option>
                          <option value="Netherlands Antilles">
                            Netherlands Antilles
                          </option>
                          <option value="New Caledonia">New Caledonia</option>
                          <option value="New Zealand">New Zealand</option>
                          <option value="Nicaragua">Nicaragua</option>
                          <option value="Niger">Niger</option>
                          <option value="Nigeria">Nigeria</option>
                          <option value="Niue">Niue</option>
                          <option value="Norfolk Island">Norfolk Island</option>
                          <option value="Northern Mariana Islands">
                            Northern Mariana Islands
                          </option>
                          <option value="Norway">Norway</option>
                          <option value="Oman">Oman</option>
                          <option value="Pakistan">Pakistan</option>
                          <option value="Palau">Palau</option>
                          <option value="Palestinian Territory, Occupied">
                            Palestinian Territory, Occupied
                          </option>
                          <option value="Panama">Panama</option>
                          <option value="Papua New Guinea">
                            Papua New Guinea
                          </option>
                          <option value="Paraguay">Paraguay</option>
                          <option value="Peru">Peru</option>
                          <option value="Philippines">Philippines</option>
                          <option value="Pitcairn">Pitcairn</option>
                          <option value="Poland">Poland</option>
                          <option value="Portugal">Portugal</option>
                          <option value="Puerto Rico">Puerto Rico</option>
                          <option value="Qatar">Qatar</option>
                          <option value="Reunion">Reunion</option>
                          <option value="Romania">Romania</option>
                          <option value="Russian Federation">
                            Russian Federation
                          </option>
                          <option value="Rwanda">Rwanda</option>
                          <option value="Saint Helena">Saint Helena</option>
                          <option value="Saint Kitts and Nevis">
                            Saint Kitts and Nevis
                          </option>
                          <option value="Saint Lucia">Saint Lucia</option>
                          <option value="Saint Pierre and Miquelon">
                            Saint Pierre and Miquelon
                          </option>
                          <option value="Saint Vincent and The Grenadines">
                            Saint Vincent and The Grenadines
                          </option>
                          <option value="Samoa">Samoa</option>
                          <option value="San Marino">San Marino</option>
                          <option value="Sao Tome and Principe">
                            Sao Tome and Principe
                          </option>
                          <option value="Saudi Arabia">Saudi Arabia</option>
                          <option value="Senegal">Senegal</option>
                          <option value="Serbia">Serbia</option>
                          <option value="Seychelles">Seychelles</option>
                          <option value="Sierra Leone">Sierra Leone</option>
                          <option value="Singapore">Singapore</option>
                          <option value="Slovakia">Slovakia</option>
                          <option value="Slovenia">Slovenia</option>
                          <option value="Solomon Islands">
                            Solomon Islands
                          </option>
                          <option value="Somalia">Somalia</option>
                          <option value="South Africa">South Africa</option>
                          <option value="South Georgia and The South Sandwich Islands">
                            South Georgia and The South Sandwich Islands
                          </option>
                          <option value="Spain">Spain</option>
                          <option value="Sri Lanka">Sri Lanka</option>
                          <option value="Sudan">Sudan</option>
                          <option value="Suriname">Suriname</option>
                          <option value="Svalbard and Jan Mayen">
                            Svalbard and Jan Mayen
                          </option>
                          <option value="Swaziland">Swaziland</option>
                          <option value="Sweden">Sweden</option>
                          <option value="Switzerland">Switzerland</option>
                          <option value="Syrian Arab Republic">
                            Syrian Arab Republic
                          </option>
                          <option value="Taiwan, Province of China">
                            Taiwan, Province of China
                          </option>
                          <option value="Tajikistan">Tajikistan</option>
                          <option value="Tanzania, United Republic of">
                            Tanzania, United Republic of
                          </option>
                          <option value="Thailand">Thailand</option>
                          <option value="Timor-leste">Timor-leste</option>
                          <option value="Togo">Togo</option>
                          <option value="Tokelau">Tokelau</option>
                          <option value="Tonga">Tonga</option>
                          <option value="Trinidad and Tobago">
                            Trinidad and Tobago
                          </option>
                          <option value="Tunisia">Tunisia</option>
                          <option value="Turkey">Turkey</option>
                          <option value="Turkmenistan">Turkmenistan</option>
                          <option value="Turks and Caicos Islands">
                            Turks and Caicos Islands
                          </option>
                          <option value="Tuvalu">Tuvalu</option>
                          <option value="Uganda">Uganda</option>
                          <option value="Ukraine">Ukraine</option>
                          <option value="United Arab Emirates">
                            United Arab Emirates
                          </option>
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="United States">United States</option>
                          <option value="United States Minor Outlying Islands">
                            United States Minor Outlying Islands
                          </option>
                          <option value="Uruguay">Uruguay</option>
                          <option value="Uzbekistan">Uzbekistan</option>
                          <option value="Vanuatu">Vanuatu</option>
                          <option value="Venezuela">Venezuela</option>
                          <option value="Viet Nam">Viet Nam</option>
                          <option value="Virgin Islands, British">
                            Virgin Islands, British
                          </option>
                          <option value="Virgin Islands, U.S.">
                            Virgin Islands, U.S.
                          </option>
                          <option value="Wallis and Futuna">
                            Wallis and Futuna
                          </option>
                          <option value="Western Sahara">Western Sahara</option>
                          <option value="Yemen">Yemen</option>
                          <option value="Zambia">Zambia</option>
                          <option value="Zimbabwe">Zimbabwe</option>
                        </select>
                      </div>
                      <div className="checkout-inps">
                        <FormControl variant="outlined" className="my-2">
                          <TextField
                            variant="outlined"
                            id="state"
                            name="state"
                            maxLength={32}
                            onChange={handleChange}
                            error={
                              value.region && value.region !== "" ? true : false
                            }
                            label="State"
                            helperText={value.regionError && value.regionError}
                          />
                        </FormControl>
                        {/*   <label htmlFor="state" className="address-inputLabel">
                            <input
                              type="number"
                              className="address-inp"
                              value={region}
                              onChange={(e) => {
                                setValue({ region: e.target.value });
                              }}
                            />
                            <span className="address-placeholders">State</span>
                          </label> */}
                      </div>
                    </div>
                  </div>

                  <div className="address-inputs">
                    <div className="address-company-name">
                      <FormControl variant="outlined" className="my-2">
                        <TextField
                          variant="outlined"
                          id="component-outlined"
                          name="company"
                          maxLength={32}
                          onChange={(e) => {
                            setValue({ company: e.target.value });
                          }}
                          error={
                            value.companyError && value.companyError !== ""
                              ? true
                              : false
                          }
                          label="Company Name"
                          helperText={value.companyError && value.companyError}
                        />
                      </FormControl>
                      {/* <label
                          htmlFor="companyname"
                          className="address-inputLabel"
                        >
                          <input
                            type="text"
                            className="address-inp"
                            value={company}
                            onChange={(e) => {
                              setValue({ company: e.target.value });
                            }}
                          />
                          <span className="address-placeholders">
                            Company Name
                          </span>
                        </label> */}
                    </div>
                  </div>

                  <div className="address-save-cancel">
                    <div className="add-save-btn">
                      <button
                        type="button"
                        onClick={() => {
                          onSubmit();
                        }}
                        className="save-address"
                      >
                        <span>Save</span>
                      </button>
                    </div>

                    <div className="add-cancel-btn">
                      <Link to="/address-book">
                        <button type="button" className="cancel-address">
                          <span>cancel</span>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(connect(null, { addAddressBook })(EditAddressBook));
